// Tabs der Sonstige-Detailseite (Handoff Sonstige Kontakte §2). Der Tab steht in der URL (?tab=),
// damit Kontext-Sidebar und Seite denselben Zustand teilen.
export const KONTAKT_TABS = ['uebersicht', 'verknuepft', 'aktivitaet', 'notizen', 'briefe'] as const;
export type KontaktTab = typeof KONTAKT_TABS[number];

export function istKontaktTab(wert: string | null | undefined): wert is KontaktTab {
  return !!wert && (KONTAKT_TABS as readonly string[]).includes(wert);
}

/** Tab aus ?tab=; unbekannt oder leer → Übersicht. */
export function kontaktTab(wert: string | null | undefined): KontaktTab {
  return istKontaktTab(wert) ? wert : 'uebersicht';
}

/** Pfad der Detailseite mit Tab (Übersicht ohne Parameter). */
export function kontaktTabPfad(id: string, tab: KontaktTab): string {
  const basis = `/admin/kontakte/kontakt/${encodeURIComponent(id)}`;
  return tab === 'uebersicht' ? basis : `${basis}?tab=${tab}`;
}

/** Ereignis nach Änderungen (Bearbeiten, Notiz, Verknüpfung …): Sidebar-Zähler und Kopf laden neu. */
export const KONTAKT_GEAENDERT = 'immo-kontakt-geaendert';

export function meldeKontaktGeaendert(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(KONTAKT_GEAENDERT));
}
